import { useEffect, useState } from "react";
import { PATH_EVENTO_PRODUCTION } from "../../../const/PATH";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { EventoSlug } from "../../utils/EventoSlug";
import { EventoFecha } from "../../utils/EventoFecha";
import SelectEntrada from "../../utils/SelectEntrada";

const Evento = ({ descount, data }) => {
  const [image, setImage] = useState(
    `${PATH_EVENTO_PRODUCTION}${data?.imagen}`
  );

  const manejarError = () => {
    setImage("/assets/img/eventos/imageNotFound.svg");
  };

  useEffect(() => {
    setImage(`${PATH_EVENTO_PRODUCTION}${data?.imagen}`);
  }, [data]);
  if (descount) {
    let descuento = 0;

    if (data?.cupones.length == 0) {
      descuento = data?.cupon_descuento;
    } else {
      descuento = data?.cupones[0].descuento;
    }

    return (
      <a
        href={`/entrada/${EventoSlug(data?.nombre, data?.id)}`}
        title="Ir al evento"
      >
        <div className="w-100 box-evento-hover border border-3 overflow-hidden">
          <div className="box-evento position-relative">
            <div
              className="overflow-hidden"
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "100%",
              }}
            >
              <div
                className="text-white cardOffer d-flex align-items-center justify-content-center"
                style={{
                  width: "70px",
                  height: "45px",
                }}
              >
                <span className="d-block GothamBold fs-6">{`${descuento}%`}</span>
              </div>
              <img
                src={image}
                onError={manejarError}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            <div
              className="w-100 text-white text-center Grifter bg-naranja"
              style={{ borderRadius: "0px 0px 0px 0px", fontSize: "10px" }}
            >
              {data?.categorias.length > 0 ? data?.categorias[0].nombre : ""}
            </div>

            <div className="text-center px-3 py-2">
              <div
                style={{ height: "2.8em" }}
                className="border-0 d-flex justify-content-center align-items-center"
              >
                <h1
                  className="Grifter fs-6  text-dark fs-6"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                  }}
                >
                  {data?.nombre}
                </h1>
              </div>

              <div className="precio fs-5  mt-2 text-dark">
                <span
                  className="d-block text-muted"
                  style={{ fontSize: "10px" }}
                >
                  Desde
                </span>
                {SelectEntrada(data?.entradas)}
              </div>
              <span
                className="d-block text-dark"
                style={{ fontSize: "10px", height: "20px" }}
              >
                {data?.fechas.length > 0
                  ? `${format(
                      new Date(
                        `${EventoFecha(data?.fechas).fecha} ${
                          EventoFecha(data?.fechas).hora
                        }`
                      ),
                      "eeee, d 'de' MMMM 'de' yyyy",
                      { locale: es }
                    ).toString()} | ${EventoFecha(data?.fechas).hora.slice(
                      0,
                      5
                    )} Hrs`
                  : null}
              </span>
              <span
                className="text-dark w-100 text-center d-block"
                style={{ fontSize: "10px" }}
              >
                {`${data?.nombre_sitio.substring(0, 15)} | ${
                  data?.localidad
                } - ${data?.provincia}`}
              </span>
              <button
                className="btn btn-custom-amarillo Grifter py-1 my-2"
                style={{ fontSize: "12px", borderRadius: "10px" }}
              >
                Comprar entradas
              </button>
            </div>
          </div>
        </div>
      </a>
    );
  }

  return (
    <a
      href={`/entrada/${EventoSlug(data?.nombre, data?.id)}`}
      title="Ir al evento"
    >
      <div
        className="w-100 box-evento-hover border border-3 overflow-hidden"
        style={{ borderRadius: "5px" }}
      >
        <div className="box-evento position-relative">
          <div
            className="overflow-hidden"
            style={{ position: "relative", width: "100%", paddingTop: "100%" }}
          >
            <div className="text-white cardOffer d-none">
              <span className="d-block GothamBold fs-5">25</span>
              <span className="d-block GothamBold fs-7 text-white">Abril</span>
            </div>
            <img
              src={image}
              onError={manejarError}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          <div
            className="w-100 text-white text-center Grifter bg-naranja"
            style={{ borderRadius: "0px 0px 0px 0px", fontSize: "10px" }}
          >
            {data?.categorias.length > 0 ? data?.categorias[0].nombre : ""}
          </div>

          <div className="text-center px-3 py-2">
            <div
              style={{ height: "2.8em" }}
              className="border-0 d-flex justify-content-center align-items-center"
            >
              <h1
                className="Grifter fs-6  text-dark "
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                }}
              >
                {data?.nombre}
              </h1>
            </div>
            <div className="precio  fs-5  mt-2 text-dark">
              <span className="d-block text-muted" style={{ fontSize: "10px" }}>
                Desde
              </span>
              {SelectEntrada(data?.entradas)}
            </div>
            <span
              className="d-block text-dark"
              style={{ fontSize: "10px", height: "20px" }}
            >
              {data?.fechas.length > 0
                ? `${format(
                    new Date(
                      `${EventoFecha(data?.fechas)?.fecha} ${
                        EventoFecha(data?.fechas)?.hora
                      }`
                    ),
                    "eeee, d 'de' MMMM 'de' yyyy",
                    { locale: es }
                  ).toString()} | ${EventoFecha(data?.fechas)?.hora.slice(
                    0,
                    5
                  )} Hrs`
                : null}
            </span>
            <span
              className="text-dark w-100 text-center d-block"
              style={{ fontSize: "10px" }}
            >
              {`${data?.nombre_sitio.substring(0, 20)} | ${data?.localidad} - ${
                data?.provincia
              }`}
            </span>
            <button
              className="btn btn-custom-amarillo Grifter py-1 my-2"
              style={{ fontSize: "12px", borderRadius: "10px" }}
            >
              Comprar entradas
            </button>
          </div>
        </div>
      </div>
    </a>
  );
};

export default Evento;
